import {reqJson, req} from './axiosFun';

export const addOrUpdateInvoice = (params) => {
    return reqJson("/api/ubiboat_website/invoice/addOrUpdate", params)
};

export const getInvoice = (params) => {
    return req("get", "/api/ubiboat_website/invoice/?userId="+params)
};

export const addAddress = (params) => {
    return reqJson("/api/ubiboat_website/address/addOrUpdate", params)
};

export const getAddress = (params) => {
    return req("get", "/api/ubiboat_website/address/list/" + params)
};

export const delAddress = (params) => {
    return reqJson("/api/ubiboat_website/address/delete" , params)
};


export const getGoodsList = (params) => {
    return req("get","/api/ubiboat_website/goods/list/?goodsName="+params)
};

export const createOrderApi = (params) => {
    return reqJson("/api/ubiboat_website/order/add",params)
}

export const getOrderPayStatusApi = (params) => {
  return req("get","/api/ubiboat_website/order/orderPayStatus/"+params)
};


export const getOrderList = (params) => {
  return req("post","/api/ubiboat_website/order/list",params)
};

export const submitInvoiceApi = (params) => {
  return reqJson("/api/ubiboat_website/sys_invoice",params)
};


export const deleteOrderApi = (params) => {
  return reqJson("/api/ubiboat_website/order/del",params)
};



// WEBPACK FOOTER //
// ./src/api/payMG.js